import React, { useRef } from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import Box from '../../../components/Common/Box';
import ChartShareButton from '../../../components/Common/ChartShareButton';

interface HistoryPoint {
  time: string;
  value: number;
}

interface PortfolioChartProps {
  data: HistoryPoint[];
}

const PortfolioChart: React.FC<PortfolioChartProps> = ({ data }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  return (
    <Box>
      <div style={{ padding: '20px', position: 'relative' }} ref={chartRef}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: 'var(--text-heading)' }}>
              Évolution du Portefeuille
            </h3>
            <ChartShareButton
              targetRef={chartRef}
              fileName="evolution_portefeuille"
            />
          </div>
        </div>

        <div style={{ height: '300px', width: '100%' }}>
          <ResponsiveContainer width='100%' height='100%'>
            <AreaChart data={data}>
              <defs>
                <linearGradient id='colorValue' x1='0' y1='0' x2='0' y2='1'>
                  <stop offset='5%' stopColor='#2563EB' stopOpacity={0.3} />
                  <stop offset='95%' stopColor='#2563EB' stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray='3 3' vertical={false} stroke='#e2e8f0' />
              <XAxis
                dataKey='time'
                tick={{ fontSize: 12, fill: '#94a3b8' }}
                tickLine={false}
                axisLine={false}
                minTickGap={30}
                tickFormatter={(str) => {
                  const date = new Date(str);
                  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
                }}
              />
              <YAxis
                tick={{ fontSize: 12, fill: '#94a3b8' }}
                tickLine={false}
                axisLine={false}
                tickFormatter={(val) => `${(val / 1000).toFixed(0)}k`}
                domain={['auto', 'auto']}
              />
              <Tooltip
                contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                }}
                formatter={(value: number) => [`${value.toLocaleString()} FCFA`, 'Valeur']}
                labelFormatter={(label) =>
                  new Date(label).toLocaleDateString('fr-FR', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })
                }
              />
              <Area
                type='monotone'
                dataKey='value'
                stroke='#2563EB'
                strokeWidth={2}
                fillOpacity={1}
                fill='url(#colorValue)'
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Box>
  );
};

export default PortfolioChart;
